export class RegistrationLearnerDataExchangeRequestDto {
    constructor(public userid: string) {
    }
}
